import * as DAOUtils from "../utils/DAOUtils";

export function getOrderMachines() {
  return DAOUtils.get("/orders/machines");
}

export function getOrderBasicData(effectiveDate) {
  return DAOUtils.get(`/orders/basicData?effectiveDate=${effectiveDate}`);
}

export function getOrderList(workListId) {
  return DAOUtils.get(`/orders/orderList?worklistId=${workListId}`);
}

export function getOrderDeliveryTypes() {
  return DAOUtils.get("/orders/deliveryTypes");
}

export function getOrderPriceList() {
  return DAOUtils.get("/orders/priceList");
}

export function getFreeContingentDetails() {
  return DAOUtils.get(`/orders/freeContingent`);
}

export function getTermsAndConditions(){
  return DAOUtils.get('/orders/termsAndConditions')
}

export function saveOrder(data, file) {
  const formData = new FormData();
  file && formData.append("file", file);
  formData.append("body", JSON.stringify(data));
  return DAOUtils.post("/orders/order", formData, { headers: { "Content-Type": "multipart/form-data" } });
}

export async function startExcelDownload(orderId) {
  return DAOUtils.post(`/orders/${orderId}/downloadExcel`);
}

export async function getDownloadedExcel(orderId, requestId) {
  return DAOUtils.get(`/orders/${orderId}/downloadExcel/${requestId}`);
}

export async function getOrdersValidation(data, file) {
  const formData = new FormData();
  file && formData.append("file", file);
  formData.append("body", JSON.stringify(data));
  return DAOUtils.post("/orders/checkoutValidation", formData, { headers: { "Content-Type": "multipart/form-data" } });
}
